module.exports = __webpack_public_path__ + "img/mail-alert.28dc2f49.svg";